module.exports = __webpack_public_path__ + "static/Dewi Liliana-98e6ea374e522be2c76ed09a015c946e.jpg";